import React from 'react';
import { Button, Modal } from 'antd';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useLogOut } from 'modules/auth';

interface IProps {
  onClose: () => void;
  open: boolean;
}

const LogOutModal: React.FC<IProps> = ({ onClose, open }) => {
  const t = useTranslations();
  const { mutate, isLoading } = useLogOut(onClose);

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onCancel={onClose}
      width="380px"
      closeIcon={false}
      styles={{
        content: { padding: '8px 10px 3px 10px', borderRadius: '12px' }
      }}
    >
      <div className="mb-5 flex flex-col items-center justify-center">
        <div className="size-29 relative">
          <Image src="/images/logout.webp" fill alt="LogOut" title="Logout" />
        </div>
        <p className="mt-5 text-lg font-semibold">{t('chiqishni_tasdiqlaysizmi')}</p>
        <p className="text-gray-400">{t('chiqishni_tasdiqlaysizmi_desc')}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button onClick={onClose} className="!py-4.5 !w-full !rounded-md !border-transparent !bg-green-500 !text-white">
          {t('bekor_qilish')}
        </Button>
        <Button
          loading={isLoading}
          onClick={() => mutate()}
          className="!py-4.5 !w-full !rounded-md !border-transparent !bg-red-500 !text-white"
        >
          {t('chiqish')}
        </Button>
      </div>
    </Modal>
  );
};

export default LogOutModal;
